import { Col, Row } from "antd";
import { useState } from "react";
import UsersGraph from "./UsersGraph";
import UserTable from "./UserTable";

const UserData = ({ data }) => {
  const [height, setHeight] = useState(null);
  return (
    <Row gutter={[8, 8]}>
      <Col xs={24} sm={24} md={24} lg={15} xl={15} id="graph_col">
        <UsersGraph data={data} setHeight={setHeight} />
      </Col>
      <Col xs={24} sm={24} md={24} lg={9} xl={9}>
        <UserTable data={data} height={height} />
      </Col>
    </Row>
  );
};

export default UserData;
